var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1757)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7692 13.5469H2.01123C1.08772 13.5469 0.333008 14.2973 0.333008 15.2251V18.8945L19.0634 29.7066H22.0159V27.3094C22.0159 26.3194 22.8239 25.5117 23.8138 25.5117H28.8436C29.8339 25.5117 30.6416 26.3197 30.6416 27.3094V29.7112H33.3942L52.3333 18.7787V15.2254C52.3333 14.3019 51.5829 13.5472 50.6551 13.5472H35.7692V13.5469Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8434 26.7944H23.8136C23.5293 26.7944 23.2944 27.0251 23.2944 27.3139V33.9732C23.2944 34.2575 23.5251 34.4924 23.8136 34.4924H28.8434C29.1277 34.4924 29.3629 34.2617 29.3629 33.9732V27.3139C29.3629 27.0297 29.1323 26.7944 28.8434 26.7944Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8479 35.7666H23.8138C22.8239 35.7666 22.0159 34.9586 22.0159 33.9686V30.9979C20.884 31.0159 18.824 31.0448 18.575 30.9053L0.333008 20.3734V43.3226H52.3333V20.2573L33.8826 30.9099C33.6105 31.0701 31.1279 30.9897 30.6416 30.9897V33.9686C30.6416 34.9631 29.8381 35.7666 28.8479 35.7666Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3333 44.6016H0.333008V46.0622C0.333008 46.9858 1.08346 47.7405 2.01123 47.7405H50.6551C51.5786 47.7405 52.3333 46.99 52.3333 46.0622V44.6016Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7972 6.90111H33.8604C35.2053 6.90111 36.3134 7.94955 36.4027 9.27646H38.8283V6.92366C38.8283 5.45415 37.6339 4.25977 36.1644 4.25977H16.4974C15.0279 4.25977 13.8335 5.45384 13.8335 6.92366V9.27646H16.2546C16.3438 7.95351 17.448 6.90111 18.7969 6.90111H18.7972Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4087 10.5547V12.2686H38.8285V10.5547H36.4087Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2488 12.2686V10.5547H13.8335V12.2686H16.2488Z",
    fill: "#8BC34A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.890ba9d920ea8e3d4264d2f08503ef21.svg";
export { ForwardRef as ReactComponent };